/*
 *
 * MemberRequests constants
 *
 */

export const DEFAULT_ACTION = 'src/MemberRequests/DEFAULT_ACTION';
